import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../../contexts/LanguageContext'
import { hasCookieConsentChoice, writeCookieConsent } from '../../lib/cookieConsent'

export default function CookieConsent({ onVisibilityChange }) {
  const { t } = useLanguage()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const pending = !hasCookieConsentChoice()
    setVisible(pending)
    onVisibilityChange?.(pending)
  }, [onVisibilityChange])

  const resolve = useCallback(
    (choice) => {
      writeCookieConsent(choice)
      setVisible(false)
      onVisibilityChange?.(false)
      window.dispatchEvent(new CustomEvent('sosvor-cookie-consent', { detail: choice }))
    },
    [onVisibilityChange]
  )

  if (!visible) return null

  return (
    <div
      className="cookie-consent"
      role="dialog"
      aria-live="polite"
      aria-label={t('cookieConsent.ariaLabel')}
    >
      <div className="cookie-consent__inner">
        <p className="cookie-consent__text">{t('cookieConsent.message')}</p>
        <div className="cookie-consent__actions">
          <Link to="/politica-privacidade" className="cookie-consent__link">
            {t('cookieConsent.learnMore')}
          </Link>
          <button
            type="button"
            className="cookie-consent__btn cookie-consent__btn--secondary"
            onClick={() => resolve('rejected')}
          >
            {t('cookieConsent.reject')}
          </button>
          <button
            type="button"
            className="cookie-consent__btn cookie-consent__btn--primary"
            onClick={() => resolve('accepted')}
          >
            {t('cookieConsent.accept')}
          </button>
        </div>
      </div>
    </div>
  )
}
